module.exports = __webpack_public_path__ + "img/icon-nav2.d82c54f9.png";